export default __webpack_public_path__ + "static/media/processallocation.fb7b9c9d.svg";